var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.container},_vm._l((_vm.searchResults),function(contact){return _c('ContactComponent',{key:contact.crmId,class:_vm.$style.contactsContainer,attrs:{"contact":contact}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c08ee662","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/SearchContacts/SearchMode/ContactsComponent.vue
// module id = PXso
// module chunks = 1